import React, { useState } from "react";
import { Download } from "lucide-react";
import ExportDialog from "./ExportDialog";

/**
 * Export button that opens a filter dialog before downloading.
 * `filters` prop determines which filter fields are shown: 'tasks' | 'expenses' | 'attendance' | 'leaves' | 'accounting' | 'all'
 */
export default function ExportButton({ endpoint, label = "Export", testid, filters }) {
  const [open, setOpen] = useState(false);
  // Derive filter set from endpoint if not explicitly given
  const filterSet = filters || endpoint.replace(".xlsx", "");
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid={testid || `export-${endpoint}`}
        className="border border-white/15 hover:border-[#FF5722] hover:text-[#FF5722] px-3 py-2 text-xs mono uppercase tracking-widest flex items-center gap-2 transition-colors"
      >
        <Download className="w-3.5 h-3.5" /> {label}
      </button>
      {open && <ExportDialog endpoint={endpoint} label={label} filters={filterSet} onClose={() => setOpen(false)} />}
    </>
  );
}
